import React, { Fragment } from 'react';

export default function ViewTemplate() {
  return (
    <>
      <h1>View Template Page</h1>
    </>
  );
}
